export const ModalNames = {
  AdjustmentAddEdit: 'AdjustmentAddEdit',
  AdjustmentDelete: 'AdjustmentDelete',
  Attachments: 'Attachments',
  CannotBeginProcessingMessage: 'CannotBeginProcessingMessage',
  CannotCalculateMessage: 'CannotCalculateMessage',
  BatchCalculation: 'BatchCalculation',
  CannotUploadMessage: 'CannotUploadMessage',
  JobErrors: 'JobErrors',
  UploadTrialBalance: 'UploadTrialBalance',
};
export const BATCH_CALCULATION_ERROR_CODE = '-2';

export const connectionsTypes = {
  GlUI: 'GL:UI',
  FileUI: 'FILE:UI',
  FileFTP: 'FILE:FTP',
};

export const accountsExcludedFromManualAdjustments = [
  'STMAUTLNOL',
];
